// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import { setElementsFromScope } from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { isPresent, keyDefaultFalseOption } from '../../utilities/general';
const sharedModalHtml = require("../../sharedHtml/modal.html");
const targetSelector = "#facility-details-screen";
const modalHtml = require("../../sharedHtml/modal.html");

const inboundSectionHtml = require("./html/inboundSection.html");
const rmsShipToAddressHtml = require("./html/rmsShipToAddressId.html");
const classificationTypesHtml = require("./html/classificationTypes.html");
const facilityfulfilmentHtml =  require("./html/supplyChainFulfillment.html");
const facilitytypeHtml =  require("./html/fulfillmentTypes.html");
const returnSupplyChain = require("./html/supplyChainReturns.html");
const returnSupplyChainTypesHtml = require("./html/supplyChainReturnTypes.html") 

run(targetSelector, (target) => {
  const countryList = target.data("country-list");
  const orgStatus = target.data("org-status-url");
  const usaStates = target.data('usa-states');
  const caProvinces = target.data('ca-provinces');
  const phoneCodes = target.data('country-phone-code-list');
  const changeStatusURL = target.data("change-status-url");
  const facilitiesDetailsJson = target.data("facility-details-json");
  const isHoneyCombUser = target.data("is-honey-comb-user");
  const defaultInboundClassificationList = target.data("default-inbound-classification");
  const fedExAccountNo = target.data("fdx-account-number");
  const hubId = target.data("hub-id");
  const backToListUrl = target.data("back-to-list");
  const editFacilityUrl = target.data("edit-url");
  const pageRefreshUrl = target.data("page-refresh-url");
  const defaultfacTypeList = target.data("default-facilty-Types-rms");
  const facTypeListJson = target.data("facility-types-json");
  const facTypeListJsonrms = target.data("facility-types-json-rms");
  const facTypeSupplyChain = target.data("facility-types-supply");
  const scFacilityTypes= target.data("supplychain-facility-types");
  const supplyChainSaveConfigURL = target.data("supply-chain-config-save-url");
  const scReturnTypes = target.data("supplychain-return-types");
  const orderProcessGuideURL = target.data("order-proccess-guide-url");
  const cacheCheck = target.data("cache-check");
  const casAccountNumber = target.data("cas-account-number");
  const isAddPermission = target.data("add-permission");
  const isEditPermission = target.data("edit-permission");
  const facilitiesUomConfig = target.data("facilities-uom-config");
  const retailerFedexAccounts = target.data('retailer-fedex-accounts');
  const retailerAccountNumber = target.data("retailer-hc-accountnumber");
  const retailerHubId = target.data("retailer-hc-hubid");
  const retailerCadCmtId = target.data("retailer-hc-hcadcmid");

  let facilityStatus = facilitiesDetailsJson.cadActive;
  let supplyChainId = facilitiesDetailsJson.cadFacId;
  let facilityNameErrorModal; 
  let isSupplyChain = '';
  let selectFromOrgModal;
  let facilityFulfillmentList = '';

 
    if(supplyChainId){
    isSupplyChain = 'supplychain';
  }
  
  const mainEl = getMainElHTML(isSupplyChain, {
    details: getDetailsData(),
    data: facilitiesDetailsJson,
    facStatusForPill: getFacilityForStatusPill(),
    statusPillClass: getStatusPill(),
    iseditPersmission : getPermissionStatus()
  });
  target.append(mainEl);

  function getMainElHTML(isSupplyChain, renderOptions){
    if(isSupplyChain){
      return $(render(require("./html/detailScreenWrapperSupplyChain.html"), renderOptions));
    }else{
      return $(render(require("./html/detailsScreenWrapper.html"), renderOptions));
    }
  }

  function getPermissionStatus(){
    if(isEditPermission){
        return  render(require("./html/changeStatusEditButton.html"),{
          facStatus: getFacilityStatus()
          });
      }
    }

    function getPencilEdit(){
      let pencilStatus = "";
      if(isEditPermission){
        pencilStatus = '<i class="fa fa-pencil q-icon-marg-left q-icon-md" aria-hidden="true"></i>';
      }
      return pencilStatus;
    }

  function getFacilityStatus(){
    let facStatus = "Activate";
    if(facilityStatus=='Y'){
      facStatus="Deactivate"
    }
    return facStatus;
  }

  function getStatusPill(){
    let statusPillClass = "q-pill-blue";
    if(facilityStatus=='N' || facilityStatus== null){
      statusPillClass="q-pill-blue-border"
    }
    return statusPillClass;
  }
  
  function getFacilityForStatusPill(){
    let facStatus = "Active";
    if(facilityStatus=='N' || facilityStatus== null){
      facStatus="Inactive"
    }
    return facStatus;
  }

  function getDetailsData(){
    if(isHoneyCombUser){
      if(isSupplyChain){
        return  render(require("./html/supplychainDetails.html"),{
          data:facilitiesDetailsJson,
          country:getCountry(),
          facilityTypesData: render(facilityfulfilmentHtml, {
            facilityType: getFulFillmentTypes(),
          }),
          returnTypesData: render(returnSupplyChain, {
            returnType: getReturnTypes()
          }),
        });
      }else{
        return  render(require("./html/hcmbDetails.html"),{
          data:facilitiesDetailsJson,
          country:getCountry(),
          facilityTypeForHoneyComb:getFacilityTypeForHoneyComb(),
          editPencil : getPencilEdit()
        });
      }
      
    }else{
      return  render(require("./html/rmsDetails.html"),{
        data:facilitiesDetailsJson,
        hubId:hubId,
        country:getCountry(),
        facilityTypeForRMS:getFacilityTypeForRms(),
        inboundClassificationTypes: render(inboundSectionHtml, {
          classificationType: getInboundClassificationTypes()
        }),
        isAuthValueOn:getAuthorizationValue(),
        stndRaNumber:getStndRaNumber(),
        editPencil : getPencilEdit(),
        fedExAccountNo:fedExAccountNo,
        casAccountNumber:casAccountNumber,
        
        rmsShipToAddress:getRmsShipToAddressVal()
      });
    }
  }

  function validateOrgStatus(){
    const orgName = facilitiesDetailsJson.cadOrganizationName;
    $.ajax({
      url: verifyOrgStatusUrl,
      data: {
        orgName: orgName
      },
      dataType: "JSON",
      type: 'POST',
      success: function(data){
        if(data.status == true){
          return true;
        }else{
          return false;
        }
      }
    });
  }

  function getCountry(){
    let country="";
    _.each(countryList, (el)=>{
      if(facilitiesDetailsJson.cadCountry == el.conCode){
        country = el.conName;
      }
    });
    return country;
  }

  const els = {};
  let rmsFacilityType=getFacilityTypeForRms();

  const elementsMap = {
    //backToList:".backToList",
    editButton:".editButton",
    changeStatus:"#changeStatus",
    editPencilBtn:".editPencilBtn",
    configSupplyChainBtn: ".configSupplyChainBtn",
    //saveConfigBtn:".save-changes-btn",
    vendorAuthorizationSection: "#vendorAuthorizationSection",
    inboundClassificationsSection: "#inboundClassificationsSection"
  };

  function init() {
    setElements();
    generateModals();    
    bindElements();
    rmsFacilityTypeHandler();
    generateErrorModals();

  }

  function setElements() {
    setElementsFromScope(els, elementsMap, target);
  }
  
  function bindElements() {
    //els.backToList.on('click', backToListHandler);
    els.editButton.on('click', editButtonHandler);
    els.editPencilBtn.on('click', editButtonHandler);
    els.changeStatus.on("click", changeStatusHandler);
    els.configSupplyChainBtn.on('click',configSupplyChainHandle);
    target.on("click", ".backToList", backToListHandler);
    //target.saveConfigBtn.on('click',saveConfigBtnHandler)
  }

  function changeStatusHandler(e){
    e.preventDefault();
    deactivateFacilitiesCall(facilitiesDetailsJson.cadId);
  }

  function rmsFacilityTypeHandler() {
    if (rmsFacilityType === "Vendor Returns") {
      els.vendorAuthorizationSection.show();
      els.inboundClassificationsSection.hide();
    } else if (rmsFacilityType === "Return Center") { 
	  els.vendorAuthorizationSection.show();
      els.inboundClassificationsSection.show();
	}else {
      els.vendorAuthorizationSection.hide();
      els.inboundClassificationsSection.show();
    }
  }

  function getFacilityTypeForHoneyComb() {
    const facilityTypeArray = _(facilitiesDetailsJson.cmrAddressAttributes).map(facilityTypeArrayTemp);
    let facilityTypeArrayResponse;
    facilityTypeArrayResponse = _.filter(facilityTypeArray, (entry => entry && entry.trim() != ''));
    return facilityTypeArrayResponse.join(", ");
  }
  
  function facilityTypeArrayTemp(data) {
    let returnValue = '';
    if(data!= null ){
      let facData = facTypeListJson;
      _.each(facData, (el)=>{
        if( el.cdmMeaning==data.caaKey ){
          returnValue = el.cdmValue;
        }  
      });
    }
    return returnValue;
  }

 function getFacilityTypeForRms() {
   const facilityTypeArray = _(facilitiesDetailsJson.cmrAddressAttributes).map(facilityTypeArrayRms);
  let facilityTypeArrayResponse;
  facilityTypeArrayResponse = _.filter(facilityTypeArray, (entry => entry && entry.trim() != ''));
  return facilityTypeArrayResponse.join(", ");
}

function facilityTypeArrayRms(data) {
  let returnValue = '';
  if (data.caaValue != '' && data.caaKey != 'inbound_classification' && data.caaKey != 'vendor_ra_required' && data.caaKey != 'vendor_standing_ra') {
    let facData = facTypeListJsonrms;
    _.each(facData, (el)=>{
      if(el.cdmMeaning == data.caaKey){
        returnValue = el.cdmValue;
      }   
    });
  }
  return returnValue;
}

  function getAuthorizationValue() {
    const getcmrAddressAttributesData = facilitiesDetailsJson.cmrAddressAttributes;
    let isAuthOn="";
    let response="";
    _.each(getcmrAddressAttributesData, (el)=>{
      if (el.caaKey == "vendor_ra_required") {
        isAuthOn = el.caaValue;
      }
    });
    if(isAuthOn == "true"){
      response = '<span class="q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue">Yes</span>';
    }else{
      response = '<span class="q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue-border">No</span>';
    }
    return response;
  }

   function getStndRaNumber(){
    const getcmrAddressAttributesData = facilitiesDetailsJson.cmrAddressAttributes;
    let stndRaNumber="Not Set";
    for(let i=0;i<getcmrAddressAttributesData.length;i++){      
        if(getcmrAddressAttributesData[i].caaKey === "vendor_standing_ra"){
          stndRaNumber = getcmrAddressAttributesData[i].caaValue;
        }
    }
    return stndRaNumber;    
  }

  function getRmsShipToAddressVal(){    
    if(facilitiesDetailsJson.cadAddressType == "inbound"){
      return render(rmsShipToAddressHtml, {
        cadShipAddressId: facilitiesDetailsJson.cadShipAddressId
      })
    }    
  }

  function getInboundClassificationTypes() {
    const response = _.map(defaultInboundClassificationList, (inboundClassificationItem) => {
      return render(classificationTypesHtml, {
        item: inboundClassificationItem,
        isOn: getInboundSelectedValue(inboundClassificationItem)
      });
    });
    return response.join("");
  }

  function getInboundSelectedValue(inboundClassificationItem) {
    const getInboundClassificationData = facilitiesDetailsJson.cmrAddressAttributes;
    let isOn = "<span class='q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue-border'>Off</span>";
    _.each(getInboundClassificationData, (el)=>{
      if (inboundClassificationItem.cdmValue == el.caaValue) {
        isOn = "<span class='q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue'>On</span>";
      }
    });
    return isOn;
  }

  function getFulFillmentTypes() {
    const response = _.map(scFacilityTypes, (fulfillmentTypesList) => {
      return render(facilitytypeHtml, {
        fTypes: fulfillmentTypesList,
        isOn: getFacilitySelectedValue(fulfillmentTypesList)
      });
    });
    return response.join("");
  }

  function getFacilitySelectedValue(fulfillmentTypesList) {
    const  getFacilitySelectedData = facilitiesDetailsJson.cmrAddressAttributes;
    let isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
    _.each(getFacilitySelectedData, (el)=>{
      if (fulfillmentTypesList.cdmValue == el.caaValue && fulfillmentTypesList.cdmValue != 'RC') {
        isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
      }
    });
    return isOn;
  }


  function getReturnTypes() {
    const response = _.map(scReturnTypes, (returnTypeList) => {
      return render(returnSupplyChainTypesHtml, {
        rTypes: returnTypeList,
        isOn: getReturnSelectedValue(returnTypeList),
        isFedexAccountOn:getFedexAccountValues(returnTypeList),
			  fedExAccountNumber:retailerAccountNumber,
			  fedExHubID:retailerHubId
      });
    });
    return response.join("");
  }

  function getFedexAccountValues(returnTypeList) {
    const  getReturnSelectedData = facilitiesDetailsJson.cmrAddressAttributes;
    let isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
    _.each(getReturnSelectedData, (el)=>{
       if (returnTypeList.cdmValue == el.caaValue && returnTypeList.cdmValue == 'RC' && retailerHubId != null && retailerHubId !="" && retailerAccountNumber != null && retailerAccountNumber !="") {
      isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
    }
    });
    return isOn;
  }

  function getReturnSelectedValue(returnTypeList) {
    const  getReturnSelectedData = facilitiesDetailsJson.cmrAddressAttributes;
    let isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
    _.each(getReturnSelectedData, (el)=>{
      if (returnTypeList.cdmValue == el.caaValue && returnTypeList.cdmValue == 'RC') {
        isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
      }
    });
    return isOn;
  }



  function backToListHandler(e){
    e.preventDefault();
    if(cacheCheck){
      window.history.go(-1);
    }else{
      window.location.href=backToListUrl;
    } 
  }

  function editButtonHandler(e){
    e.preventDefault();
    window.open(editFacilityUrl+ "&cadId="+facilitiesDetailsJson.cadId, "_self");
  }
  
  function generateErrorModals(){

    facilityNameErrorModal = $(render(sharedModalHtml,{
      title: 'Activate Facility Error',
      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
      body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"		
    }));
    $('body').append(facilityNameErrorModal);
  }

  function deactivateFacilitiesCall(cadId){
    //In future if requirement comes to change either to change only title or btn text,hence introduced separetely 
    let confirmModalBtnText = "Activate Facility";
    let confirmModalTitle  = "Activate Facility";
    if(facilityStatus=='Y'){
      confirmModalBtnText="Deactivate Facility";
      confirmModalTitle ="Deactivate Facility";
    }
    if(confirmModalBtnText === "Activate Facility"){
      if(!orgStatus && !(_(orgStatus).isString())){ 
        showFacilityNameErrorModal();
      }
      else{
        changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
      }
    }else{
      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
    }
   
  }

  function showFacilityNameErrorModal(){
    facilityNameErrorModal.modal('show');
  }
//Supply config start


  //$('body').on('click', '.supply-tab-active', function (e)
  
  function configSupplyChainHandle(e){
    e.preventDefault();
    
    //let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
   // let parent = $(".dropdown-parent-" + pIndex).parents('tr');
   // let row = $(".data-table-component").dataTable().api().row(parent);
    let facilities = facilitiesDetailsJson;
   
    facId = facilities.cadFacId;
    facName = facilities.cadLocationName;

    
    getFacilitiesUomConfig(facilitiesUomConfig, facId); //Need to get facility config first since retailer config can override default facility UOM config once it is editable
    populateSupplychainConfigurationModal(facilities);
    
    showOrganizationSelectModal();
    //generateModals(facName);

    $(function () {
      $("#fedex-account").click(function () {
          if ($(this).is(':checked')) {
              $("#fedexAcntChecked").show();
          } else {
              $("#fedexAcntChecked").hide();
          }
      });
  });
  }

  $(function () {
    $("#returns-center").click(function () {
        if ($(this).is(':checked')) {
          if($("#fedex-account").is(":checked")){
            $("#fedex-account1").show();
            $("#fedexAcntChecked").show();
          }
          else{
            $("#fedex-account1").show();
          }
        } else {
            $("#fedex-account1").hide();
            $("#fedexAcntChecked").hide();
        }
             $("#fedex-account").click(function () {
              if ($(this).is(':checked')) {
                  $("#fedexAcntChecked").show();
              } else {
                  $("#fedexAcntChecked").hide();
              }
          });
        }); 
});


  let facName="";
  let facId="";
  //generateModals(facName);

  function generateModals(facName){
    selectFromOrgModal = $(render(sharedModalHtml,{
        title: 'Configure Supply Chain Facility',
        footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-changes-btn">Save Changes</a>',
        body: render(require("./html/supplyChainConfigModal.html"),{
          facilityName:facName,
          link: orderProcessGuideURL,
          rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts),          
        }),
        topCloseBtn: true,
        autoHideTop: true,
        modalDialogClass: "q-modal-dialog-800"
    }));
  $('body').append(selectFromOrgModal);
  }

  function getRenderedFedexAccounts(retailerFedexAccountsList) {
    const retailerFacilityHtml = '<option value="{%- retailerFedexAccountsListVal.cmtId %}">{%- retailerFedexAccountsListVal.cmtAccountNo %}</option>';
    const response = _.map(retailerFedexAccountsList, (retailerFedexAccountsListVal) => {
      return render(retailerFacilityHtml, {
        retailerFedexAccountsListVal: retailerFedexAccountsListVal
      });
    });

    return response.join("");
  }

  function populateSupplychainConfigurationModal(data){
              $(".facName").text(data.cadLocationName);
              $(".facId").text(data.cadFacId);
              
              $.each(data.cmrAddressAttributes, function(i, attribute) {
                if(attribute.caaValue=='FC'){
                    $('#fulfillment-center').attr('checked', true);
                }
                if(attribute.caaValue=='DC'){
                    $('#distribution-center').attr('checked', true);
                }
               if(attribute.caaValue=='RC'){
                $('#returns-center').attr('checked', true);
                if(retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "" && $('#returns-center').is(':checked') ){
                $("#fedex-account1").show();
                $('#fedex-account').attr('checked', true);
                }
                if($('#fedex-account').is(':checked') && retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != ""){
                $("#fedexAcntChecked").show();
                $("#fedex-account-numbers").val(retailerCadCmtId).trigger("change");
                }
               
                }else{

                  if($('#returns-center').is(':checked')){
                    $("#fedex-account1").show();
                   }
                if($('#fedex-account1').is(':checked')){                  
                    $("#fedexAcntChecked").show();
                } 
                }
                
                if(attribute.caaValue=='IN'){
                    $('#international-fulfillment-center').attr('checked', true);
                }
                if(attribute.caaValue=='UOM'){
                  $("#additional-units-of-measure").attr('checked', true);
              }
                
              
             
              })
            }

  function showOrganizationSelectModal(){
    selectFromOrgModal.modal('show');
  }

  function hideOrganizationSelectModal(){
    selectFromOrgModal.modal('hide');
  }

  $(document).on('click','.save-changes-btn', saveSupplyChainConfig);


  function saveSupplyChainConfig(){
    hideOrganizationSelectModal();
    let submitModal = new SubmitModalFlow();
    submitModal.init();
    submitModal.showLoadingModal();
    $.ajax({
      url: supplyChainSaveConfigURL,
      data: {
        facId: facId,
        fulfillmentCenter: $("#fulfillment-center").is(":checked"),
        distributionCenter: $("#distribution-center").is(":checked"),
        internationalFulfillmentCenter: $("#international-fulfillment-center").is(":checked"),
        returnsCenter: $("#returns-center").is(":checked"),
        fedexAccount: $("#fedex-account").is(":checked"),
        additionalUnitsOfMeasure : $("#additional-units-of-measure").is(":checked"),
        cmtId:getFedexAccountNumber($("#fedex-account-numbers").val(), $("#returns-center").is(":checked"), $("#fedex-account").is(":checked"))
      },
      dataType: "JSON",
      type: 'POST',
      success: function (data) {
        if (data.success == "Success") {
          submitModal.showSuccessModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
        else {
          submitModal.showFailureModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
      }
    });
    
  };

  function getFedexAccountNumber(fedexAccountValue, returnsCenterFlag, fedexAccountFlag){
    if (returnsCenterFlag && fedexAccountValue !=null && fedexAccountFlag) {
     return fedexAccountValue;
    } else {
     return "";
    }
    }

//supply chain end
  function changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId) {
    let deactivateFacilityModal = new SubmitModalFlow({
      confirmModalTitle: confirmModalTitle,
      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
      confirmModalBtnText: confirmModalBtnText,
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        deactivateFacilityModal.showLoadingModal();
        deactivateFacility({ url: changeStatusURL, success: deactivateSuccess, error: deactivateFailure });
        function deactivateFacility({ url, success, error }) {
          $.ajax({
            url: url,
            data: {
              cadIds: cadId
            },
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function deactivateSuccess() {
          deactivateFacilityModal.showSuccessModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
        function deactivateFailure() {
          setTimeout(function () {
            deactivateFacilityModal.hideAllModals();
          }, 6000);
        }
      }
    });
    deactivateFacilityModal.init();
    deactivateFacilityModal.showConfirmModal();
  }

  function getFacilitiesUomConfig(data, facId){
    _.each(data, function(facConfig){
      if(facConfig.facId==facId){
        if(facConfig.facUomEditable==1){
          $("#additional-units-of-measure").prop('disabled', false);
        }else{
          $("#additional-units-of-measure").prop('disabled', true);
        }
      }
    });
   }

  init();

});



// WEBPACK FOOTER //
// ./src/pages/facilities/details.js


// WEBPACK FOOTER //
// ./src/pages/facilities/details.js